import { render, staticRenderFns } from "./MobileOrderHistoryDetail.vue?vue&type=template&id=55cfce84&"
import script from "./MobileOrderHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./MobileOrderHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports